import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useCallback, useEffect } from 'react';
import { shallow as shallow$1 } from '../../../node_modules/zustand/esm/shallow.js';
import { styled } from 'styled-components';
import { motion } from 'framer-motion';
import useAlertStore, { TOAST_DURATION } from '../../store/alerts.js';
import { mediaMobile } from '@fabric-app/ui/constants/styled-utils';
import { getCompatUI } from '@fabric-app/compat/capabilities/ui';
import { IconPath16FabricFace } from '@fabric-app/icons/svg';

const Toast = styled(motion.div).withConfig({
  displayName: "ToastDisplay__Toast",
  componentId: "sc-b9e76a40-0"
})([
  `display:flex;align-items:center;justify-content:center;white-space:nowrap;background:rgba(0,0,0,0.8);border-radius:8px;padding:8px;font-weight:500;font-size:16px;line-height:24px;color:white;cursor:pointer;width:min-content;`,
  `{font-size:14px;line-height:20px;white-space:pre-wrap;width:max-content;max-width:calc(100vw - 32px);}`
], mediaMobile);
const ToastDisplay = ({ alert: toast }) => {
  const { SHOW_BRAND_MORE } = getCompatUI();
  const removeAlert = useAlertStore((state) => state.removeAlert, shallow$1);
  const elementId = `toast-${toast.id}`;
  const timeout = useRef(null);
  const dismiss = useCallback((duration = TOAST_DURATION) => {
    if (timeout.current) clearTimeout(timeout.current);
    timeout.current = window.setTimeout(() => {
      removeAlert(toast.id);
    }, duration);
    return () => {
      if (timeout.current) clearTimeout(timeout.current);
    };
  }, [
    removeAlert,
    toast.id
  ]);
  useEffect(() => {
    const cancel = dismiss();
    return () => {
      cancel();
    };
  }, [
    dismiss
  ]);
  const onClick = (e) => {
    if (toast.onClick) toast.onClick(e);
    if (e.defaultPrevented) return;
    dismiss(0);
  };
  return /* @__PURE__ */ jsxs(Toast, {
    id: elementId,
    onClick,
    initial: {
      opacity: 0,
      y: -10
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: -10
    },
    children: [
      SHOW_BRAND_MORE && /* @__PURE__ */ jsx(IconPath16FabricFace, {
        style: {
          width: 20,
          height: "auto",
          marginRight: 8
        }
      }),
      toast.content
    ]
  });
};

export { ToastDisplay as default };
//# sourceMappingURL=ToastDisplay.js.map
